let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i2OFv"), load("28R2l"), load("eb06U"), load("6gLOy"), load("9x7AJ"), load("34R0T")]).then(() => parcelRequire('f2tcq'));